
export default  {
    // BASE_API_URL : 'https://uat-backend.b4salary.io/api/v1/',
     BASE_API_URL : 'https://journey-api.b4salary.com/api/v1/',
    // BASE_API_URL:"http://localhost:3000/api/v1/",
 
    loan:{
      LOGIN:'customer-journey/login',
      OTP_VERIFY:"customer-journey/otp-verify", 
      RESEND_OTP:"customer-journey/resend-otp",
      CUSTOMER_DETAILS: "lead-service/get-customer-details",
      PAN_VERIFICATION:"customer-journey/verify-pan",
      ELIGIBILITY_CHECK:"customer-journey/check-eligibility",
      LOAN_QUOTE:"lead-service/loan-quote-decision",
      LOAN_GENERATE:"lead-service/generate-loan-quote",
      DETAILS_PERSONAL:"customer-journey/update-personal-details",
      EMPLOYMENT_DETAILS:"customer-journey/update-employment-details",
      REQUIRED_DOCS:"lead-service/required-docs",
      UPLOAD_DOCS:"lead-service/pay-slip-upload",
      BANK_VERIFY:"lead-service/bank-account-verification",
      LEAD_LIST:"lead-service/get-status-lead-list",
      LEAD_DETAIL:"lead-service/get-lead-view-detail",
      RAZORPAY_ORDER_ID:"razor-pay/create-payment-order",
      MASTER_DATA:"lead-service/get-master-docs",
      PAYMENT_HISTORY:"lead-service/get-repayment-history",
      REDIRECT_TO_JOURNEY: "lead-service/redirect-to-journey",
      GET_CAPTCHA:"/index.php/Api/EnquiryController/generate_captcha",
      ENQUIRY:"/Api/EnquiryController/enquire",
      EKYc_DETAIL:"lead-service/initiate-ekyc",
      ACCOUNT_AGGREGATOR:'lead-service/account-aggregator-initiate',
      AGGREGATOR_RESPONSE:  "Website/RepeatInstantJourneyController/verifyAggregator",
    }
}


